import { useState, useEffect } from 'react';

const getViewportFlags = () => {
  if (typeof window === 'undefined') {
    return { isMobile: false, isTablet: false };
  }
  return {
    isMobile: window.innerWidth <= 768,
    isTablet: window.innerWidth <= 992 && window.innerWidth > 768,
  };
};

const useScrollWindow = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(() => getViewportFlags().isMobile);
  const [isTablet, setIsTablet] = useState(() => getViewportFlags().isTablet);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    const handleResize = () => {
      const flags = getViewportFlags();
      setIsMobile(flags.isMobile);
      setIsTablet(flags.isTablet);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [scrolled]);

  return { scrolled, isMobile, isTablet };
};

export default useScrollWindow;
